export const abuse = {
  title: 'Report Abuse',
  subtitle: 'We take abuse reports seriously and investigate each case thoroughly. Please follow our process below to report any abuse.',
  howWeHandle: 'How We Handle Abuse Reports',
  sendReport: 'Send your abuse report to',
  legalNotice: 'For legal entities, please also include',
  steps: {
    reception: {
      title: 'Report Reception',
      description: 'We receive your abuse report and assign it a unique case number for tracking'
    },
    review: {
      title: 'Initial Review',
      description: 'Our team reviews the report and acknowledges receipt within 24 hours'
    },
    investigation: {
      title: 'Investigation',
      description: 'We thoroughly investigate the reported issue and verify all provided evidence'
    },
    resolution: {
      title: 'Resolution',
      description: 'We take appropriate action and provide you with a detailed response'
    }
  },
  requiredInfo: {
    title: 'What to Include in Your Report',
    subtitle: 'Required Information',
    items: [
      'Detailed description of the abuse',
      'Date and time of the incident',
      'IP addresses involved',
      'Any relevant logs or evidence',
      'Your contact information'
    ]
  },
  commitment: {
    title: 'Our Commitment',
    items: [
      'Fast initial response within 24 hours',
      'Thorough investigation of all reports',
      'Regular updates on case progress',
      'Transparent communication',
      'Fair and effective resolution'
    ]
  }
};